import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unfold",
  "use": "icon-unfold-usage",
  "viewBox": "0 0 20.306 20.305",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20.306 20.305\" id=\"icon-unfold\">\r\n  <path id=\"icon-unfold_收起\" d=\"M10.458,10.119a.473.473,0,0,0-.609,0L.168,18.4a.443.443,0,0,0-.039.644L1.2,20.162a.447.447,0,0,0,.609.041L9.871,13.62a.453.453,0,0,1,.575,0L18.507,20.2a.447.447,0,0,0,.611-.037l1.072-1.117a.443.443,0,0,0-.039-.646l-9.693-8.284Zm-9.145.148a.275.275,0,0,0,.386.024L9.875,3.614a.453.453,0,0,1,.573,0l8.061,6.581a.447.447,0,0,0,.611-.037l1.072-1.117a.443.443,0,0,0-.039-.646L10.458.111a.439.439,0,0,0-.585,0L.168,8.381a.443.443,0,0,0-.039.646l1.184,1.241Z\" transform=\"translate(20.313 20.304) rotate(180)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/unfold.svg
// module id = IV9r
// module chunks = 5